import React from 'react'
import ErrorDialogContext from './ErrorDialogContext'

export default function useErrorDialog () {
    return React.useContext(ErrorDialogContext)
}